module.exports = __webpack_public_path__ + "media/images/flags/ky-f6b09f6374dc85b04c037069589f9901.svg";